export default __webpack_public_path__ + "static/media/pipol_pay.37258fd0.png";